// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/Reconnect/OAuth2/Processing/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_Actions_Reconnect_OAuth2_Processing($id: uuid!) {
  apps_connections_by_pk(id: $id) {
    id
    status
    name
    user {
      id
      vaxiom_person {
        id
        first_name
        last_name
      }
    }
  }
}

`